module.exports = __webpack_public_path__ + "static/img/recepit_bkg_2.24e775b9.png";